const multiDAlgorithmsData = [
    {
        id: 'gradient-descent',
        name: 'Gradient Descent',
        description: 'An iterative optimization algorithm used to find the local minimum of a function.',
        type: 'Optimization method',
        route: '/multi-dimensional-algorithms/gradient-descent',
    },
    {
        id: 'newtons-method',
        name: 'Newton\'s Method',
        description: 'An iterative method for finding successively better approximations to the roots (or zeroes) of a real-valued function.',
        type: 'Optimization method',
        route: '/multi-dimensional-algorithms/newtons-method',
    },
];

export default multiDAlgorithmsData;